require('./accountsBuyAmazonGiftCardMaxLimit.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
// @helpers
const { formatText, FormattedText } = require('core/i18n').i18n;
const { formatAmount } = require('utilities/currencyHelper');
// @commons
const WizardError = require('components/commons/wizardError/wizardError');
// @constants
const { AMAZON_GIFT_CARD_MAX_AMOUNT
} = require('constants/accountAmazonGiftCard');
const { 
    AMAZON_PROMOCIONES_STEP_THREE,
    AMAZON_GIFT_CARD_TIPO_PROCESS
} = require('constants/tagging');
//@utils
const { recordProcess } = require("utilities/tagging");

class AccountsBuyAmazonGiftCardMaxLimit extends React.Component {
    componentDidMount() {
        recordProcess(
            AMAZON_GIFT_CARD_TIPO_PROCESS, 
            "paso 3/error", 
            {
                descripcionError: formatText('buyAmazonGiftCardMaxLimit-title'),  
                nombrePagina: AMAZON_PROMOCIONES_STEP_THREE
            }, 
            true
        );
    }

    render() {
        const { handleCancelClick, handleRetryClick } = this.props;
        let goBackButtonLabel = <FormattedText value="common-retry" format="uppercase" />;
        const mainButton = {
            label: goBackButtonLabel,
        };
        const secondaryButton = {
            label: <FormattedText value="common-cancel" />
        };

        return (
            <div className="account-buy-amazon-gift-card-max-limit col-xs-9 center-block">
                <WizardError
                    errorMessage={formatText('buyAmazonGiftCardMaxLimit-title')}
                    mainButton={mainButton}
                    secondaryButton={secondaryButton}
                    onMainButtonClick={handleRetryClick}
                    onSecondaryButtonClick={handleCancelClick}
                >
                    <div className="account-buy-amazon-gift-card-max-limit__error-content">
                        <FormattedText value="buyAmazonGiftCardMaxLimit-content" injectedStrings={[formatAmount(AMAZON_GIFT_CARD_MAX_AMOUNT)]}/>
                    </div>
                    <div className="account-buy-amazon-gift-card-max-limit__help-text-content">
                        <FormattedText value="amazonGiftCard-helpBoxDescription" />
                    </div>
                </WizardError>
            </div>
        );
    }
}

AccountsBuyAmazonGiftCardMaxLimit.propTypes = {
    handleCancelClick: PropTypes.func.isRequired,
    handleRetryClick: PropTypes.func.isRequired,
};

module.exports = AccountsBuyAmazonGiftCardMaxLimit;
